import { LockOutlined } from "@ant-design/icons";

const AuthFooter = () => {
  return (
    <div className="flex items-start gap-2 justify-center text-text-muted">
      <LockOutlined style={{ fontSize: 16, marginTop: 1 }} />
      <h4>Your Info is safely secured</h4>
    </div>
  );
};

export default AuthFooter;